
import { inject, Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { EnvironmentService } from '../environment.service';

@Injectable({ providedIn: 'root'})
export class AppInsightsService {
    environmentService = inject(EnvironmentService);
    appInsights: ApplicationInsights | undefined;

    constructor() {        
        if (this.environmentService.isProduction() || this.environmentService.isUAT() || this.environmentService.isQA()) {
            const connectionString = this.environmentService.getAppInsightsConnectionString();
            if (!connectionString) {
                // add custom behavior to handle this scenario
                console.error('Application Insights key not found.');
                return;
            }

            this.appInsights = new ApplicationInsights({
                config: {
                    connectionString: connectionString,
                    enableAutoRouteTracking: true, // optional: auto-log all route changes
                    enableCorsCorrelation: true,
                    // The SDK's default unload-flush handler uses the deprecated `unload`
                    // event, which Chrome now logs as a Permissions Policy violation.
                    // Excluding it here still leaves `pagehide`/`visibilitychange` in
                    // place, so telemetry still flushes on navigation away.
                    disablePageUnloadEvents: ['unload'],
                    correlationHeaderExcludedDomains:[
                        'maps.googleapis.com',
                        'www.maps.googleapis.com', 
                        'www.googleapis.com', 
                        'identitytoolkit.googleapis.com',
                        'fonts.gstatic.com', 
                        'fonts.googleapis.com' 
                    ]
                },
            }); 

            this.appInsights.loadAppInsights();
        }
    }

    // helper methods to track a variety of events and metric
    logPageView(name?: string, url?: string) {
        this.appInsights?.trackPageView({
            name: name,
            uri: url,
        });
    }

    logEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights?.trackEvent({ name: name }, properties);
    }

    logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        this.appInsights?.trackMetric({ name: name, average: average }, properties);
    }

    logException(exception: Error, severityLevel?: number) {
        this.appInsights?.trackException({ exception: exception, severityLevel: severityLevel });
    }

    logTrace(message: string, properties?: { [key: string]: any }) {
        this.appInsights?.trackTrace({ message: message }, properties);
    }
}